import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ThirdPartyForm_Children_Update_Mutation = graphql(`
  mutation ThirdPartyForm_Children_Update(
    $childIds: [Id!]!
    $organizationId: Id!
    $versionData: VersionDataInput
  ) {
    updateChildren(
      childIds: $childIds
      organizationId: $organizationId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useUpdateChildrenMutation = () =>
  useGraphQLMutation(ThirdPartyForm_Children_Update_Mutation);
